import { Analytics, AnalyticsInstance } from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';

let gtmInstance: AnalyticsInstance;

export const initialize = ({ trackPageViews }: { trackPageViews: boolean }) => {
  gtmInstance = Analytics({
    app: 'bootuitjes-checkout',
    plugins: [
      googleTagManager({ containerId: process.env.REACT_APP_GTM_ID })
    ]
  });

  if (trackPageViews) {
    gtmInstance.page()
  }
}

export const track: AnalyticsInstance['track'] = (...args) =>
  gtmInstance.track(...args)
